import styled from 'styled-components';

import { media } from '../../helpers/breakpoints';
import { RatingGroup } from '../../components/PageWrappers/AdDetails/components/GoogleReviews/StarRatingGroup/StarRatingGroup';
import { BaseModal } from '../../components/Toolkit/Modal/BaseModal';
import { TabSelector } from '../../components/Toolkit/TabSelector/TabSelector';
import { DealerPages } from './DealerPage';

export const DealerDetailsWrapper = styled.div`
  flex: auto;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing.S12};
  ${media.large} {
    padding-bottom: ${({ theme }) => theme.spacing.M24};
  }
`;

export const DealerDetails = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
  flex-direction: column;

  ${media.large} {
    align-items: center;
    align-self: stretch;
    width: 760px;
    gap: ${({ theme }) => theme.spacing.M24};
    flex-direction: row;
  }
`;

export const DealerSubtext = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
  ${RatingGroup} {
    margin-left: 0;
  }
`;

export const DealerSubtextDivider = styled.span`
  &:after {
    width: ${({ theme }) => theme.spacing.S4};
    height: ${({ theme }) => theme.spacing.S4};
    background: ${({ theme }) => theme.colors.WHITE};
    margin-left: ${({ theme }) => theme.spacing.S2};
    margin-right: ${({ theme }) => theme.spacing.S2};
    content: '';
    border-radius: 50%;
    display: block;
  }
`;

export const DealerLogo = styled.img`
  width: ${({ theme }) => theme.spacing.L48};
  height: ${({ theme }) => theme.spacing.L48};
  border-radius: ${({ theme }) => theme.spacing.S4};

  ${media.large} {
    width: ${({ theme }) => theme.spacing.XL64};
    height: ${({ theme }) => theme.spacing.XL64};
  }
`;

export const DealerInfoLogo = styled.img`
  width: ${({ theme }) => theme.spacing.L40};
  height: ${({ theme }) => theme.spacing.L40};
  border-radius: ${({ theme }) => theme.spacing.S4};

  ${media.large} {
    width: ${({ theme }) => theme.spacing.L48};
    height: ${({ theme }) => theme.spacing.L48};
  }
`;

export const Main = styled.div`
  padding-top: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    display: grid;
    grid-template-columns: 260px 1fr;
    grid-gap: ${({ theme }) => theme.spacing.L40};
  }
`;

export const Sidebar = styled.div`
  display: none;
  padding-top: ${({ theme }) => theme.spacing.M16};
  padding-bottom: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    display: block;
  }
`;

export const Body = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const SBaseModal = styled(BaseModal)`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  max-height: none;
  border-radius: 0;
`;

// spacing added to accommodate the fixed footer
export const SModalBody = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.XL72};
`;

export const DealerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.large} {
    align-items: flex-start;
  }

  span {
    color: ${({ theme }) => theme.colors.WHITE};
    ${({ theme }) => theme.fontSize.S12};
    ${media.large} {
      ${({ theme }) => theme.fontSize.M14};
    }
  }

  h1 {
    ${({ theme }) => theme.fontSize.L18};
    margin-right: ${({ theme }) => theme.spacing.M16};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 0 1 auto;
    color: ${({ theme }) => theme.colors.WHITE};
    ${media.large} {
      ${({ theme }) => theme.fontSize.H32};
    }
  }
`;

export const Tabs = styled.div`
  display: block;
  padding-top: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    display: grid;
    grid-template-columns: 260px 1fr;
    grid-gap: ${({ theme }) => theme.spacing.L40};
  }
`;

export const STabSelector = styled(TabSelector<DealerPages>)`
  position: relative;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    margin-left: 300px;
    max-width: 552px;
  }
`;

export const TabItem = styled.span`
  ${({ theme }) => theme.fontSize.L18}
`;
